import axios from 'axios';
import { getEnvironmentVariable } from '../utils';
import { getAuthTokens } from '../providers/authTokenProvider';

const BASE_URL = getEnvironmentVariable('REACT_APP_API_URL');

const axiosInstance = axios.create({
    baseURL: BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

const platformURL = getEnvironmentVariable('REACT_APP_PLATFORM_URL');

const endpointsWithoutToken: string[] = [
    platformURL + '/JWT/session/login',
    platformURL + '/JWT/session/login',
];

const reactTokenEndpoints: string[] = [
    '/decisions/list/popular',
    '/categories',
    '/decisions/list/trend',
    '/decisions/list/bycategory',
];

const isProtectedEndpoint = (endpoint: string | undefined): boolean => {
    if (!endpoint) {
        return false;
    }

    return !endpointsWithoutToken.some(publicURL => endpoint.startsWith(publicURL));
};

const isReactEndpoint = (endpoint: string | undefined): boolean => {
    if (!endpoint) {
        return false;
    }

    return reactTokenEndpoints.some(template => endpoint.startsWith(template));
};

export const getTokenForEndpoint = (endpoint: string | undefined): string => {
    const tokens = getAuthTokens();

    if (isReactEndpoint(endpoint)) {
        return tokens.reactToken;
    }

    return tokens.sessionToken;
};

axiosInstance.interceptors.request.use(
    (config) => {
        if (!isProtectedEndpoint(config.url)) {
            return config;
        }

        // config.headers.Authorization = `Bearer ${getTokenForEndpoint(config.url)}
        config.headers.Authorization = 'b902a9e20dc0001d7d43a0402e7bcd4561242164';

        return config;
    },
    (error) => {
        return Promise.reject(error);
    },
);

export default axiosInstance;
